import Checkbox from './checkbox';

export default function RadioButton(props) {
    return <Checkbox { ...props } square={false}/>
}